import { MakeCall } from './createMakeCall';
import { BookingModificationRequestPayload } from './types/BookingModificationDetails';

// create a booking modification request by tenant
const createBookingModificationRequest =
  (makeCall: MakeCall) =>
  (conversationId: number, payload: BookingModificationRequestPayload) =>
    makeCall<BookingModificationRequestPayload>(
      'POST',
      `/api/v2/conversation/${conversationId}/change`,
      { data: payload },
    );
export { createBookingModificationRequest };
